export const resolveURLPath = (from = '', relPath = ''): string => {
  const stack: string[] = [];
  let parts: string[] = [];

  if (!relPath.startsWith('/')) {
    parts = [...parts, ...from.split('/').filter(Boolean)];
  }

  parts = [...parts, ...relPath.split('/').filter(Boolean)];

  for (const part of parts) {
    if (part === '.') {
      continue;
    }

    if (part === '..') {
      if (!stack.length) {
        throw new Error('Path is out of bounds');
      }

      stack.pop();
      continue;
    }

    stack.push(part);
  }

  return `/${stack.join('/')}`;
};
